module.exports = __webpack_public_path__ + "static/media/img_familia.3efba959.jpg";